"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthoriserInitializer = exports.AuthoriserInitializationError = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const authoriser_1 = require("./authoriser");
const AUTHORIZER_ERROR = 'Authoriser initialization error';
class AuthoriserInitializationError extends web_ui_framework_1.InitializerError {
    constructor(message) {
        super(AUTHORIZER_ERROR, message);
    }
}
exports.AuthoriserInitializationError = AuthoriserInitializationError;
class AuthoriserInitializer extends web_ui_framework_1.Initializer {
    constructor() {
        super();
        this.launch = () => {
            try {
                return new authoriser_1.MbAuthoriser();
            }
            catch (e) {
                throw new AuthoriserInitializationError(e);
            }
        };
    }
}
exports.AuthoriserInitializer = AuthoriserInitializer;
//# sourceMappingURL=authoriser.initializer.js.map